/* Viretta – Black Week lead pop-up 2026 (snippets/v2-bw26-popup.liquid, assets/v2-bw26-popup.css).
   Design: website canvas page 12, version 4 »Tæppet går« (owner yes 26 Oct 2026). The rules (#45, #51, #52, #54, #60):
   - opens by itself after 5 s (owner 27 Oct; was 15 s), at 30 % scroll or on exit intent (computer) – whichever comes first – but only after the
     Cookie Information choice (and at least 3 s after it); comes back 24 h after a close; never after a sign-up;
   - stops when Black Week opens at midnight, 13 Nov 2026 (the snippet stops rendering at the same moment);
   - not for visits from our mails (utm_medium=email or _kx – remembered for this session only);
   - a 5-Ply sign-up on the page (owner 26 Oct): not while its field is in use or for 3 s after; a yes to the newsletter
     there counts as signed up;
   - after a close, the top bar takes turns between today's message and »Skriv din liste til Black Week ›« (#52);
   - what it remembers (closed / signed up) is kept between visits only with consent to functional cookies, otherwise for
     this session only.
   E-mail → Klaviyo (company Wfe5y7) list SzGKE7 with source popup-bw26 + event »BW26 tilmeldt« (page, product, trigger);
   the list → event »BW26 liste« and the profile property bw26_liste. Views, yes, no, sign-ups and lists go to
   Shopify.analytics as »bw26_popup« (the store's pixels follow the visitor's consent).
   Test on an unpublished theme: ?bw26test=hook | mail | done opens that step at once. */
(function () {
  var root = document.getElementById('bw26');
  if (!root || window.V2BW26) return;
  window.V2BW26 = true;

  var END = 1794524400000;                       /* 13 Nov 2026 00:00 Copenhagen – Black Week opens (#60) */
  var CO = 'Wfe5y7', NL = 'SzGKE7', REV = '2025-01-15', DAY = 864e5;
  var test = /[?&]bw26test=(hook|mail|done)\b/.exec(location.search);
  if (test && window.Shopify && Shopify.theme && Shopify.theme.role === 'main') test = null;   /* never on the live theme */
  if (Date.now() >= END && !test) return;

  var dlg = root.querySelector('.bw26__dialog');
  var side = root.getAttribute('data-side') || location.pathname;
  var prod = root.getAttribute('data-prod') || '';
  var st0 = root.getAttribute('data-st') || '';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var start = Date.now();
  var trig = '', opened = false, armed = false, loaded = false, lastFocus = null, mail = '';

  /* ---- memory: between visits only with consent to functional cookies ---- */
  function functional() {
    try { return !!(window.CookieInformation && CookieInformation.getConsentGivenFor && CookieInformation.getConsentGivenFor('cookie_cat_functional')); }
    catch (e) { return false; }
  }
  function get(k) { try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { (functional() ? localStorage : sessionStorage).setItem(k, v); } catch (e) {} }
  try { if (/[?&](utm_medium=email|_kx=)/i.test(location.search)) sessionStorage.setItem('bw26_sub', '1'); } catch (e) {}
  if (!test && (get('bw26_sub') || get('bw26_done'))) return;

  /* ---- a 5-Ply sign-up on the page (owner 26 Oct): not while its field is in use or for 3 s after;
          a yes to the newsletter there counts as signed up (assets/v2-klaviyo.js shows [data-v2-klok] when it went through) ---- */
  var KL = 'form[data-v2-kl][data-source^="5ply"]', klAt = 0;
  function klForm(el) { return el && el.closest ? el.closest(KL) : null; }
  ['focusin', 'input', 'submit'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (klForm(e.target)) klAt = Date.now(); }, true);
  });
  document.addEventListener('submit', function (e) {
    var f = klForm(e.target); if (!f) return;
    var nl = f.querySelector('[data-v2-nl]'), ok = f.querySelector('[data-v2-klok]');
    if (!nl || !nl.checked || !ok || !window.MutationObserver) return;
    var mo = new MutationObserver(function () { if (!ok.hidden) { mo.disconnect(); set('bw26_sub', '1'); } });
    mo.observe(ok, { attributes: true, attributeFilter: ['hidden'] });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }, true);
  function klInUse() {
    var a = document.activeElement, f = klForm(a);
    if (f && a.matches && a.matches('input, button, select, textarea')) return true;
    if (document.querySelector(KL + ' button[aria-busy="true"]')) return true;
    return Date.now() - klAt < 3000;
  }

  /* ---- measuring: the store's pixels decide by consent ---- */
  function track(action, extra) {
    try {
      var d = { action: action, side: side, trigger: trig };
      for (var k in extra || {}) d[k] = extra[k];
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bw26_popup', d);
    } catch (e) {}
  }

  /* ---- the styles, the photo and the station pictures load late: at 10 s or 20 % scroll, or when it opens ---- */
  var cssReady = null;
  function css() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (ok) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = root.getAttribute('data-css');
      l.onload = ok; l.onerror = ok; document.head.appendChild(l);
      setTimeout(ok, 3000);
    });
    return cssReady;
  }
  function load() {
    if (loaded) return; loaded = true; css();
    [].forEach.call(root.querySelectorAll('[data-srcset], [data-src]'), function (el) {
      if (el.getAttribute('data-srcset')) el.srcset = el.getAttribute('data-srcset');
      if (el.getAttribute('data-src')) el.src = el.getAttribute('data-src');
    });
  }

  /* ---- the steps ---- */
  function view(v) {
    dlg.setAttribute('data-view', v);
    [].forEach.call(root.querySelectorAll('[data-bw26-view]'), function (el) { el.hidden = el.getAttribute('data-bw26-view') !== v; });
    var h = root.querySelector('[data-bw26-view="' + v + '"] [data-bw26-h]');
    if (h) dlg.setAttribute('aria-labelledby', h.id);
    return h;
  }

  function open(t, o) {
    if (opened) return;
    opened = true; trig = t; o = o || {};
    load();
    lastFocus = document.activeElement;
    view(o.view || 'hook');
    var img = root.querySelector('.bw26__img'), shown = false;
    function go(reveal) {
      if (shown) return; shown = true;
      root.hidden = false;
      root.classList.toggle('bw26--reveal', !!reveal);
      if (reveal) { root.classList.add('bw26--busy'); setTimeout(function () { root.classList.remove('bw26--busy'); }, 700); }
      root.classList.add('is-open');
      document.documentElement.classList.add('bw26-lock');
      try { dlg.focus({ preventScroll: true }); } catch (e) { dlg.focus(); }
      track('view');
    }
    css().then(function () {
      if (reduce || o.reveal === false) return go(false);
      /* the curtain only lifts on a photo that is ready – at most 0.6 s, otherwise the finished picture shows */
      var timer = setTimeout(function () { go(false); }, 600);
      var ready = img && img.decode ? img.decode() : Promise.resolve();
      ready.then(function () { clearTimeout(timer); go(true); }, function () { clearTimeout(timer); go(false); });
    });
  }

  function close(why) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open', 'bw26--reveal', 'bw26--busy');
    root.hidden = true;
    document.documentElement.classList.remove('bw26-lock');
    if (!get('bw26_done')) { set('bw26_closed', String(Date.now())); bar(); }
    track(why || 'close');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---- the top bar (#52): only when the bar has one message (today's), so the theme's own rotation is untouched ---- */
  function bar() {
    /* 27 Oct: the bar is in the page already (snippets/v2-bw26-popup, part: 'bar', shown before paint) – only wire it once;
       the template is the fallback for a page without it */
    var p = document.getElementById('bw26-bar');
    if (p && p.getAttribute('data-bw26-on')) return;
    if (!p) {
      /* owner 27 Oct: the Black Week bar above everything – its own strip at the very top of the page */
      var tpl = document.getElementById('bw26-bar-tpl');
      if (!tpl) return;
      p = document.createElement('div');
      p.id = 'bw26-bar'; p.className = 'bw26-bar bw26-top';
      p.appendChild(tpl.content.cloneNode(true));
      document.body.insertBefore(p, document.body.firstChild);
    }
    p.setAttribute('data-bw26-on', '1');
    css();
    /* owner 27 Oct: »I think we should hide the 30 days« – while the Black Week bar shows, it replaces the theme's announcement bar
       (30 dages returret …); when the campaign script stops, the announcement bar is back by itself */
    document.documentElement.classList.add('bw26-bar-on');
    [].forEach.call(document.querySelectorAll('.shopify-section--announcement-bar'), function (a) { a.style.display = 'none'; });
    p.querySelector('button').addEventListener('click', function () { open('bar', { reveal: false }); });
  }

  /* ---- when: 5 s, 30 % scroll or exit intent, after the cookie choice ---- */
  function arm() {
    if (armed) return;
    armed = true;
    var last = Number(get('bw26_closed') || 0);
    if (last) bar();
    if (last && Date.now() - last < DAY) return;   /* closed within 24 h: only the top bar */
    var t15, tLoad;
    function fire(t) {
      if (!armed) return;
      if (get('bw26_sub')) { disarm(); return; }
      if (klInUse()) { if (t === '15s') t15 = setTimeout(function () { fire('15s'); }, 1000); return; }
      disarm(); open(t, { reveal: t !== 'exit' });
    }
    function pct() { var h = document.documentElement.scrollHeight - window.innerHeight; return h > 0 ? window.scrollY / h : 0; }
    function onScroll() { var p = pct(); if (p >= 0.2) load(); if (p >= 0.3) fire('scroll'); }
    function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) fire('exit'); }
    function disarm() {
      armed = false; clearTimeout(t15); clearTimeout(tLoad);
      window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onOut);
    }
    var gone = Date.now() - start;
    t15 = setTimeout(function () { fire('15s'); }, Math.max(3000, 5000 - gone));   /* owner 27 Oct: 5 s (was 15 s) */
    tLoad = setTimeout(load, Math.max(0, 2000 - gone));
    window.addEventListener('scroll', onScroll, { passive: true });
    if (mq('(min-width: 768px)') && mq('(pointer: fine)')) document.addEventListener('mouseout', onOut);
  }
  function choiceMade() { return /(?:^|;\s*)CookieInformationConsent=/.test(document.cookie); }

  /* ---- controls ---- */
  [].forEach.call(root.querySelectorAll('[data-bw26-x]'), function (b) { b.addEventListener('click', function () { close('x'); }); });
  root.querySelector('[data-bw26-no]').addEventListener('click', function () { close('no'); });
  root.querySelector('[data-bw26-close]').addEventListener('click', function () { close('luk'); });
  root.querySelector('[data-bw26-yes]').addEventListener('click', function () {
    var h = view('mail'); track('yes');
    var input = root.querySelector('.bw26__input');
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    if (!input.matches(':focus') && h) h.focus();
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close('esc'); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(dlg.querySelectorAll('button, [href], input'), function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1], at = document.activeElement;
    if (e.shiftKey && (at === a || at === dlg)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && at === z) { e.preventDefault(); a.focus(); }
  });

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + CO, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: REV }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }

  var form = root.querySelector('form[data-bw26-view="mail"]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('.bw26__input'), err = form.querySelector('[data-bw26-err]'), btn = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      err.textContent = 'Tjek din e-mailadresse.'; err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return;
    }
    err.hidden = true; input.removeAttribute('aria-invalid');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var props = { bw26_side: side, bw26_produkt: prod, bw26_trigger: trig, bw26_kilde: 'popup-bw26' };
    var job = test ? Promise.resolve() : Promise.all([
      post('subscriptions/', { data: { type: 'subscription', attributes: { custom_source: 'popup-bw26',
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: NL } } } } }),
      post('events/', { data: { type: 'event', attributes: { properties: props,
        metric: { data: { type: 'metric', attributes: { name: 'BW26 tilmeldt' } } },
        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } } } })
    ]);
    job.then(function () {
      mail = email; set('bw26_done', '1'); track('signup');
      var h = view('done'); preselect();
      if (h) h.focus();
    }).catch(function () {
      err.textContent = 'Det gik ikke – prøv igen om lidt.'; err.hidden = false;
    }).then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });

  var cards = root.querySelectorAll('[data-bw26-card]');
  [].forEach.call(cards, function (c) {
    c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
  });
  function preselect() { [].forEach.call(cards, function (c) { if (st0 && c.getAttribute('data-st') === st0) c.setAttribute('aria-pressed', 'true'); }); }

  var save = root.querySelector('[data-bw26-save]'), saved = root.querySelector('[data-bw26-saved]');
  save.addEventListener('click', function () {
    var picks = [].filter.call(cards, function (c) { return c.getAttribute('aria-pressed') === 'true'; })
      .map(function (c) { return c.querySelector('.bw26__cardname').textContent.trim(); }).join(', ');
    save.disabled = true;
    var job = (test || !mail) ? Promise.resolve() : post('events/', { data: { type: 'event', attributes: {
      properties: { liste: picks, bw26_side: side },
      metric: { data: { type: 'metric', attributes: { name: 'BW26 liste' } } },
      profile: { data: { type: 'profile', attributes: { email: mail, properties: { bw26_liste: picks } } } } } } });
    job.then(function () {
      saved.textContent = 'Gemt.'; saved.hidden = false; track('list', { liste: picks });
      setTimeout(function () { close('saved'); }, 2500);
    }).catch(function () {
      saved.textContent = 'Det gik ikke – prøv igen om lidt.'; saved.hidden = false; save.disabled = false;
    });
  });

  /* ---- phones: keep the sheet above the keyboard ---- */
  if (window.visualViewport) {
    var vv = window.visualViewport;
    var fit = function () {
      root.style.setProperty('--bw26-vh', vv.height + 'px');
      root.style.setProperty('--bw26-kb', Math.max(0, window.innerHeight - vv.height - vv.offsetTop) + 'px');
    };
    vv.addEventListener('resize', fit); vv.addEventListener('scroll', fit); fit();
  }

  /* ---- go ---- */
  if (test) { load(); open('test', { view: test[1], reveal: test[1] === 'hook' }); if (test[1] === 'done') preselect(); return; }
  if (document.documentElement.classList.contains('bw26-bar-on')) bar();   /* the bar shown before paint gets its button at once */
  if (choiceMade()) arm();
  else {
    /* Cookie Information also fires this event on a first page load, before any choice (the categories are still null –
       seen on the theme preview 26 Oct 2026), so only the consent cookie counts as the visitor's choice. */
    var onChoice = function () {
      var tries = 0;
      (function check() {
        if (choiceMade()) { window.removeEventListener('CookieInformationConsentGiven', onChoice); arm(); }
        else if (++tries < 5) setTimeout(check, 300);
      })();
    };
    window.addEventListener('CookieInformationConsentGiven', onChoice);
    /* if the banner never loads (blocked), start anyway after 8 s */
    setTimeout(function () { if (!window.CookieInformation) arm(); }, 8000);
  }
})();
